<script setup lang="ts">
interface RequisitionFormValues {
  requestType: 'BUY' | 'SELL' | ''
  requester: string
  amount: number | ''
  currency: string
  exchange: number | ''
  destinationAccount: string
  sourceCountry: string
  transferMethod: string[]
  validityPeriod: number | ''
  discount: string
  description: string
}

defineProps<{
  values: RequisitionFormValues
}>()
</script>

<template>
    <div class="px-8 pt-2 pb-10">
        <div class="flex flex-col gap-6">

            <div class="flex flex-col gap-4 border border-[#E0E0E0] text-[#1A1A1A] rounded-xl p-4">

                <div class="flex items-center gap-2">
                    <Badge :label="values.requestType === 'SELL' ? 'فروش' : 'خرید'" :bg-color="values.requestType === 'SELL'
                        ? '#E9FBF8'
                        : '#F2E3F4'
                        " :text-color="values.requestType === 'SELL'
                            ? '#0F8F86'
                            : '#CB30E0'
                            ">
                        <template #icon>
                            <img :src="values.requestType === 'SELL'
                                ? '/svg/requests.svg'
                                : '/svg/requestsPurp--.svg'
                                " class="w-4 h-4" alt="" />
                        </template>
                    </Badge>

                    <Badge v-if="values.requestType === 'SELL'" label="100٪ تخفیف کارمزد تراکنش اول" bg-color="#E8F5FF"
                        text-color="#0E59FA">
                        <template #icon>
                            <img src="/svg/Discount.svg" class="w-4 h-4" alt="" />
                        </template>
                    </Badge>

                </div>

                <div class="flex flex-col lg:grid grid-cols-3 gap-2">
                    <div class="flex items-start justify-between text-xs font-medium rounded-[10px] p-2 bg-[#F6F6F6]">
                        <div class="flex flex-col gap-1">
                            <span class="text-[#6C6C6C] text-xs">
                                درخواست کننده
                            </span>

                            <span class="text-black text-sm font-medium">
                                نام و نام خانوادگی
                                <!-- {{ values.requester }} -->
                            </span>
                        </div>

                        <span class="text-black text-xs font-fa font-medium">
                            <!-- {{ values.requester }} -->
                            2324
                        </span>
                    </div>

                    <div class="flex items-start justify-between text-xs font-medium rounded-[10px] p-2 bg-[#F6F6F6]">
                        <div class="flex flex-col gap-1">
                            <span class="text-[#6C6C6C] text-xs">
                                حجم
                            </span>

                            <span class="text-black text-sm font-fa font-medium">
                                1000 دلار
                                <!-- {{ values.amount }}
                                {{ values.currency }} -->
                            </span>
                        </div>
                    </div>

                    <div class="flex items-start justify-between text-xs font-medium rounded-[10px] p-2 bg-[#F6F6F6]">
                        <div class="flex flex-col gap-1">
                            <span class="text-[#6C6C6C] text-xs">
                                نرخ تبادل
                            </span>

                            <span class="text-black text-sm font-fa font-medium">
                                {{ values.exchange }}
                                تومان
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="values.requestType === 'SELL'" class="flex flex-col lg:grid grid-cols-2">
                    <div class="flex flex-col gap-1">
                        <span class="text-xs text-[#6C6C6C]">
                            حساب مقصد
                        </span>

                        <span class="font-fa text-sm font-medium text-black">
                            Blue Bank - 2541 2541 2541 2541
                            <!-- {{ values.destinationAccount }} -->
                        </span>
                    </div>

                    <div class="flex flex-col gap-1">
                        <span class="text-xs text-[#6C6C6C]">
                            کشور مبدا
                        </span>

                        <div class="flex items-center gap-2 font-fa text-sm font-medium text-black">
                            <img src="/svg/turkey.svg" />
                            ترکیه
                            <!-- {{ values.sourceCountry }} -->
                        </div>
                    </div>
                </div>

                <div class="flex flex-col gap-1">
                    <span class="text-xs text-[#6C6C6C]">
                        روش انتقال
                    </span>

                    <span v-if="values.requestType === 'SELL'" class="font-fa text-sm font-medium text-black">
                        <!-- {{ values.transferMethod.join(', ') }} -->
                        بین بانکی, پی پال, رولوت (فقط امکان رولوت), رولوت (با امکان تراکنش بین بانکی)
                    </span>

                    <div v-else class="flex flex-col gap-2.5">
                        <!-- Transfer -->
                        <div class="space-y-1">
                            <div class="flex items-center gap-2">
                                <img src="/svg/Transfer-bank.svg" width="20" height="20" />

                                <span class="text-xs text-[#1A1A1A]">
                                    بین‌بانکی
                                </span>
                            </div>

                            <div class="flex items-center gap-2">
                                <img src="/svg/bankIcon.svg" width="20" height="20" />

                                <span class="text-xs font-medium text-[#6C6C6C]">
                                    America Bank - 2541 2541 2541 2541
                                </span>
                            </div>
                        </div>

                        <!-- Paypal -->
                        <div class="space-y-1">
                            <div class="flex items-center gap-2">
                                <img src="/svg/paypal.svg" width="20" height="20" />

                                <span class="text-xs text-[#1A1A1A]">
                                    پی‌پال
                                </span>
                            </div>

                            <div class="flex items-center gap-2">
                                <img src="/svg/bankIcon.svg" width="20" height="20" />

                                <span class="text-xs font-medium text-[#6C6C6C]">
                                    America Bank - 2541 2541 2541 2541
                                </span>
                            </div>
                        </div>

                        <!-- Rev -->
                        <div class="space-y-1">
                            <div class="flex items-center gap-2">
                                <img src="/svg/revolut.svg" width="20" height="20" />

                                <span class="text-xs text-[#1A1A1A]">
                                    رولوت (فقط امکان رولوت)
                                </span>
                            </div>

                            <div class="flex items-center gap-2">
                                <img src="/svg/bankIcon.svg" width="20" height="20" />

                                <span class="text-xs font-medium text-[#6C6C6C]">
                                    America Bank - 2541 2541 2541 2541
                                </span>
                            </div>
                        </div>

                        <div class="space-y-1">
                            <div class="flex items-center gap-2">
                                <img src="/svg/revolut.svg" width="20" height="20" />

                                <span class="text-xs text-[#1A1A1A]">
                                    رولوت (با امکان تراکنش بین بانکی)
                                </span>
                            </div>

                            <div class="flex items-center gap-2">
                                <img src="/svg/bankIcon.svg" width="20" height="20" />

                                <span class="text-xs font-medium text-[#6C6C6C]">
                                    America Bank - 2541 2541 2541 2541
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="flex flex-col gap-1">
                    <span class="text-xs text-[#6C6C6C]">
                        مدت اعتبار
                    </span>

                    <span class="font-fa text-sm font-medium text-black">
                        {{ values.validityPeriod }}
                        روز
                    </span>
                </div>

                <div class="flex flex-col gap-1">
                    <span class="text-xs text-[#6C6C6C]">
                        توضیحات
                    </span>

                    <span class="font-fa text-sm font-medium text-black">
                        {{ values.description || '-' }}
                    </span>
                </div>

            </div>

            <div class="flex flex-col gap-3.5 bg-[#F6F6F6] border border-[#E0E0E0] text-[#1A1A1A] rounded-xl p-4">
                <div class="flex items-center justify-between font-bold">
                    <span class="text-xs">
                        مجموع
                        {{ values.requestType === 'SELL' ? 'دریافتی' : 'پرداختی' }}
                        کاربر
                    </span>

                    <span class="font-fa text-lg">
                        {{ (210009).toLocaleString() }}
                        تومان
                    </span>
                </div>

                <div class="flex items-center justify-between">
                    <span class="text-xs">
                        خالص
                    </span>

                    <span class="font-fa text-sm">
                        {{ (2130000).toLocaleString() }}
                        تومان
                    </span>
                </div>

                <div class="flex items-center justify-between">
                    <div class="flex flex-col gap-2 text-xs">
                        <span>
                            کارمزد
                            <span class="text-[#0E59FA]">
                                نحوه محاسبه؟
                            </span>
                        </span>

                        <span>
                            حاوی 10% مالیات بر ارزش افزوده
                        </span>
                    </div>

                    <span class="font-fa text-sm">
                        {{ (12300).toLocaleString() }}
                        تومان
                    </span>
                </div>

                <div v-if="values.requestType === 'SELL'" class="flex items-center justify-between">
                    <span class="text-xs">
                        تخفیف
                    </span>

                    <span class="font-fa text-sm">
                        {{ (2130000).toLocaleString() }}
                        تومان
                    </span>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped></style>
